import React, {useState, useEffect} from 'react';
import {Grid, Backdrop, Typography, CircularProgress, ListItem, ListItemIcon, ListItemText, Button} from '@material-ui/core/';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import {functions} from 'constants/index';
import ApiServices from 'services/ApiServices';
// import { showMessageSuccessSimple } from '../../../../../../services/SweetAlert';
import MensajeAlerta from 'components/ResponseElement'
import ModalConfirmation from 'components/ModalConfirmation/ModalConfirmation';
import modalStyles from 'components/ModalConfirmation/styles';
import LoadingSpinner from 'components/LoadingSpinner';
import Form from 'components/Form/FormTwoColumns';
import { showMessageSuccessSimple } from 'services/SweetAlert';
import ListaDeTiposDeCasosAReportar from './CheckBoxList'
import Divider from '@material-ui/core/Divider';

function ReportarCasoInformatica(props) {
    const classesModal = modalStyles(),
        classes = useStyles(),
        [mensaje, setMensaje] = useState({tipoError:'', tipoMensaje:''}),
        [open, setOpen] = useState(false),
        [loading, setLoading] = useState(false);

    const functionReportarCasoAInformatica = async () =>{
        elements['observaciones'].isError = false;
        setElements({...elements})
        if(!elements['observaciones'].value) {
            elements['observaciones'].isError = true;
            setElements({...elements})
            return;
        }        
        setLoading(true)
        let saveData = {idSolicitud: props.idSolicitud, observaciones: elements.observaciones.value ? elements.observaciones.value.trim() : '',}
        // console.log('saveData: ', saveData)
        try{
            const response =  await ApiServices.reportarCasosAInformatica.create(saveData);
            if(response.error!==null){
                setMensaje({tipoError:'error', tipoMensaje:'Oops!. '+response.error.message})
                setOpen(true)                      
            }else{
                props.CerrarYActualizar()
                showMessageSuccessSimple('¡BIEN! ','Caso de Solicitud # '+props.idSolicitud+' Reportado a Informática por inconsistencias de datos en la solicitud.')
            }   
        }catch(exception){
            if (exception.status===404) {
                setMensaje({tipoError:'error', tipoMensaje:'¡Oops!' + "Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste."})                    
                setOpen(true)                      
            }
            else {
                setMensaje({tipoError:'error', tipoMensaje:'¡Oops!' + "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste."})                    
                setOpen(true)                                          
            }
        }                       
        setLoading(false)
    }

    const [elements,setElements] = useState({
        observaciones: {
            idelement: "observaciones",  value:'', label: "Observación", pattern:"^[\\w1-9 _Ññ.,!¡\"#$%&/()=¿?'@*-]{5,1024}$", minWidth: 500,
            validators: ['required'], errorMessages:['Observación requerida, sin tíldes y sin espacios al inicio y final'], isError:false, elementType:'input'
        },            
        // contraseña: {  idelement: "contraseña",  value:'', label: "Contraseña *", pattern:"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@#$!¡:;{}+=^~|%*¿?&/-])[A-Za-z\\d$@#$!¡:;{}+=^~|%*¿?&/-]\\S{6,20}$", validators: ['required'], errorMessages:['Contraseña requerida'], isError:false, elementType:'password' },
    });   

    return (
        <div>
            <ModalConfirmation
                scroll="body"
                actionAdd={functionReportarCasoAInformatica}
                open={props.open}
                closeModal={props.closeModal}
                titleButton="Sí, estoy seguro!"
            >
                <Typography className={classesModal.title} >
                    Al Reportar la solicitud No. {props.datosCiudadanoTable.idSolicitud} a "Reportar Caso a Informática" estaría reportando la información que no viene en la solicitud de RENAP.    
                </Typography>
                {/* <Typography className={classesModal.description} >
                    <Divider />
                        En el listado, seleccionar la información que desea reportar a Informática.
                    <Divider />
                </Typography>
                <Grid className={classes.gridWith}>
                    <ListaDeTiposDeCasosAReportar />
                </Grid>    */}
                <Typography className={classesModal.descriptionTwo} >
                    <Divider />            
                        En el campo de "Observación", detalle algún comentario de los casos a reportar a informática. (Campo no requerido).
                    <Divider />
                </Typography>
                <Grid className={classes.form}>
                    <Form elements={elements} />
                </Grid>                
                <Typography className={classesModal.description} >
                    ¿ Está seguro de "Reportar caso a Informática" ?
                </Typography>
                <LoadingSpinner open={loading} message="Reportando caso a Informática, Espere un momento por favor!"/>
            </ModalConfirmation>            
        </div>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(ReportarCasoInformatica);